import image from "@/assets/holiday-cards/holiday-card-wallpaper-downloads.png";
import { DayDefinition } from "../DayDefinition.js";
import { WallPaperCard } from "../shared/wallpaper/WallpaperCard.js";
import type { WallpaperGridProps } from "../shared/wallpaper/WallpaperGrid.js";

/**
 * Class Wallpaper_Downloads
 *
 * Represents the Wallpaper Downloads card.
 */
export class Wallpaper_Downloads extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-lightbrown2022";

	public image = image;

	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "wallpaper-downloads";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Festive Phone &amp; Desktop Backgrounds";
		this.content = (
			<WallPaperCard
				items={wallpapers}
				language={"EN"}
				links={{
					allDesktop:
						"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Desktop.zip",
					allMobile:
						"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Mobile.zip",
				}}
			/>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title =
			"Fonds d'écran (de saison) pour téléphone et bureau d’ordinateur";
		this.content = (
			<WallPaperCard
				items={wallpapers}
				language={"FR"}
				links={{
					allDesktop:
						"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Desktop.zip",
					allMobile:
						"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Mobile.zip",
				}}
			/>
		);
	}
}

const wallpapers: WallpaperGridProps["items"] = [
	{
		desktop_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Desktop-01.jpg",
		mobile_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Mobile-01.jpg",
		thumbnail:
			"https://rootree.ca/wp-content/uploads/2022/11/thumb_Holiday_Backgrounds_Thumbnails-01.jpg",
	},
	{
		desktop_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Desktop-02.jpg",
		mobile_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Mobile-02.jpg",
		thumbnail:
			"https://rootree.ca/wp-content/uploads/2022/11/thumb_Holiday_Backgrounds_Thumbnails-02.jpg",
	},
	{
		desktop_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Desktop-03.jpg",
		mobile_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Mobile-03.jpg",
		thumbnail:
			"https://rootree.ca/wp-content/uploads/2022/11/thumb_Holiday_Backgrounds_Thumbnails-03.jpg",
	},
	{
		desktop_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Desktop-04.jpg",
		mobile_link:
			"https://rootree.ca/wp-content/uploads/2022/11/Holiday_Backgrounds_Mobile-04.jpg",
		thumbnail:
			"https://rootree.ca/wp-content/uploads/2022/11/thumb_Holiday_Backgrounds_Thumbnails-04.jpg",
	},
];
